






















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import TableComponent from './Components/SummaryReportTable.vue';
import ImportLog from '@/components/common/ValidationMessage/ImportLog.vue';
import HeaderInfo from '../../ExpansionPanel/FinExpansionPanel.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';

const namespace: string = "financialReport";
@Component({
  components: {
    TableComponent,
    FormattedNumber,
    HeaderInfo,
    NavButtons,
    ImportLog
  }
})
export default class SummaryReportComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;
  @Getter('selectedReport', {namespace}) report: any;
  @Getter('grantInfo', {namespace}) grantInfo: any;
  @Prop() financialReportSections: any;
  @Prop() validations: any
  @Prop() model: any;
  @Prop() readonly: any;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() currency: string;
  @Prop() enableButton: any;
  @Prop() isFinalReport: boolean;

  mounted() {}

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }

  get dataModel() {
    if (!this.model.summary) {
      this.model.summary = {};
      this.model.summary.summaryReport = [];
      this.model.summary.consolidation = {};
    }
    return this.model.summary;
  }

  get header() {
    if(this.schema && this.schema.properties && this.schema.properties.detailedExpenseHeaders) {
      return this.schema.properties.detailedExpenseHeaders.items
    }
  }

  get hideCols() {
    if(this.schema) {
      return this.schema["x-hideCols"] || [];
    }
  }

  get hasCashFlow() {
    if(this.schema) {
      return this.schema["x-hasCashFlow"] || false;
    }
  }

  get currencyList() {
    return this.financialReport.currencyList;
  }

  get budgetCategories() {
    return this.financialReport.categories;
  }

  get budget() {
    let obj: any = {};
    if (
      this.financialReport.grantData &&
      this.financialReport.grantData.applicationBudget
    ) {
      obj = this.financialReport.grantData.applicationBudget;
    }
    return obj;
  }
}
